<script setup lang="ts">
import type { DisciplineDetailsTutor } from '../model/interfaces'

import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'

import { useAdminRoutes } from '@shared/lib/routes'
import { LinkTextPrimaryMedium } from '@shared/ui/links'
import { AppIcon } from '@shared/ui/icons'

import { useDisciplineSubstituteTutors } from '../model/discipline-substitute-tutors.hook'

defineOptions({
  name: 'DisciplineSubstituteTutors',
})

defineProps<{
  tutors: DisciplineDetailsTutor[]
}>()

const {
  listRef,
  refIsOverflowing,
  refIsExpanded,
  toggleExpanded,
} = useDisciplineSubstituteTutors()

const getTutorUrl = (tutorId: number): string => useAdminRoutes('admin.tutor.show', { tutor_id: tutorId }) ?? ''
</script>

<template>
  <div :class="['discipline-substitute-tutors', { 'discipline-substitute-tutors--expanded': refIsExpanded }]">
    <div
      ref="listRef"
      class="discipline-substitute-tutors__list"
    >
      <LinkTextPrimaryMedium
        v-for="(tutor, index) in tutors"
        :key="tutor.id"
        class="discipline-substitute-tutors__item"
        :href="getTutorUrl(tutor.id)"
      >
        {{ tutor.first_name }} {{ tutor.last_name }}{{ index < tutors.length - 1 ? ',' : '' }}
      </LinkTextPrimaryMedium>
    </div>
    <button
      v-if="refIsOverflowing || refIsExpanded"
      type="button"
      class="discipline-substitute-tutors__chevron"
      :aria-label="refIsExpanded ? 'Collapse substitute tutors' : 'Expand substitute tutors'"
      @click="toggleExpanded"
    >
      <AppIcon
        :icon="faChevronDown"
        size="small"
        color="slate-500"
      />
    </button>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineSubstituteTutors.scss" />
